import { isStandalone } from '../lib/platform.js';

/**
 * 内置浏览器（微信 / QQ / 微博 …）引导层。
 *
 * 这些 WebView 会拦截自定义 scheme，连 https 形式的 Universal Link 也常常
 * 拦掉，所以「自动唤起」在这里必然失败。硬跳只会看到一个错误弹窗，
 * 正确的做法是把「去外部浏览器打开」这一步交给用户，并说清楚点哪里。
 */
export default function BrowserGuide({ browserName, onClose, onCopy, downloadUrl }) {
  // 已经装到桌面（没有地址栏）时，「点右上角」就不再成立了
  const standalone = isStandalone();

  return (
    <div className="guide" role="dialog" aria-modal="true" aria-label="在浏览器中打开">
      <span className="guide__arrow" aria-hidden="true">
        ↖
      </span>

      <div className="guide__bubble">
        <strong>请用手机浏览器打开</strong>
        <ol className="guide__steps">
          {standalone ? (
            <>
              <li>复制下面的链接</li>
              <li>粘贴到手机浏览器（如 Safari、Chrome）地址栏</li>
              <li>打开后即可自动唤起 App 或下载</li>
            </>
          ) : (
            <>
              <li>
                点击右上角 <strong>···</strong>
              </li>
              <li>
                选择 <strong>在浏览器打开</strong>
              </li>
            </>
          )}
        </ol>

        <div className="guide__actions">
          {onCopy ? (
            <button type="button" className="btn btn--primary" onClick={onCopy}>
              复制链接
            </button>
          ) : null}

          {downloadUrl ? (
            <a className="btn btn--ghost" href={downloadUrl}>
              直接去下载
            </a>
          ) : null}
        </div>
      </div>

      <button type="button" className="guide__close" onClick={onClose}>
        {browserName ? `我还是想在${browserName}里打开` : '关闭'}
      </button>
    </div>
  );
}
